/**
 * Pipe-set meta flag: swap IWM Root CW↔CCW in WPS/PQR reports (follow-behind).
 * Stored telemetry never rewritten. No separate CW/CCW WPS reports.
 */

export function readSwapIwmBugType(metaSection: unknown): boolean {
  if (!metaSection || typeof metaSection !== 'object' || Array.isArray(metaSection)) {
    return false
  }
  return (metaSection as Record<string, unknown>).swapIwmBugType === true
}

export const IWM_ROOT_MAPPING_BUTTON_LABEL = 'Configure IWM Root mapping'

export const IWM_ROOT_MODE_KEEP_LABEL = 'As logged'
export const IWM_ROOT_MODE_FLIP_LABEL = 'Swap'

export const IWM_ROOT_MODE_KEEP_ARROW = 'CW→CW, CCW→CCW'
export const IWM_ROOT_MODE_FLIP_ARROW = 'CW→CCW, CCW→CW'

export const IWM_ROOT_SWAPPED_BADGE_LABEL = 'swapped'

/** Instant hover copy for the Root-row Swapped badge. */
export function iwmRootSwappedBadgeTitle(): string {
  return 'Root CW and CCW are swapped in WPS and PQR reports. Data on this page is unchanged.'
}
